import { Observable } from "rxjs";
import { tap, flatMap, switchMap, debounceTime } from "rxjs/operators";
import { formOperation } from "../../wrappers/formOperation";
import { TActionsDefinitionsList } from "./TAction";
import { action, routeAction } from "./actionFunctions";

export const actions: TActionsDefinitionsList = [
    routeAction("VIEW_AUTH_AUTHENTICATOR", (obs$, lens, set, get) => {
        obs$.pipe(
            flatMap(() => formOperation("GetAuthenticatorPage", lens.authenticator_page.get()(get()))),
            tap((response) => set(lens.authenticator_page.set(response))),
        ).subscribe();
    }),
    action("AUTHENTICATOR_BEGIN_ENROLMENT", (obs$: Observable<null>, lens, setState, getState) => {
        obs$.pipe(
            tap(() => setState(lens.authenticator_page.children.begin_enrolment.status.set("loading"))),
            switchMap(() => formOperation("BeginAuthenticatorEnrolment", lens.authenticator_page.children.begin_enrolment.get()(getState()))),
            tap((response) => setState(lens.authenticator_page.children.begin_enrolment.set(response))),
        ).subscribe();
    }),
    action("AUTHENTICATOR_CONFIRM_CODE_CHANGE", (obs$: Observable<string>, lens, setState) => {
        obs$.pipe(
            tap((code) => setState(lens.authenticator_page.children.confirm_enrolment.edited.code.set(code))),
        ).subscribe();
    }),
    action("AUTHENTICATOR_CONFIRM_ENROLMENT", (obs$: Observable<null>, lens, setState, getState) => {
        obs$.pipe(
            // The split input emits its final keystroke more than once; the second submit then
            // fails its own sms step-up and bounces a just-enrolled user back to /auth/two-factor.
            debounceTime(300),
            tap(() => setState(lens.authenticator_page.children.confirm_enrolment.status.set("submitting"))),
            switchMap(() => formOperation("ConfirmAuthenticatorEnrolment", lens.authenticator_page.children.confirm_enrolment.get()(getState()))),
            tap((response) => setState(lens.authenticator_page.children.confirm_enrolment.set(response))),
            // Re-read the page so the enrolled state (and its date) comes from the server
            // rather than being assumed from a successful submit.
            switchMap(() => formOperation("GetAuthenticatorPage", lens.authenticator_page.get()(getState()))),
            tap((response) => setState(lens.authenticator_page.set(response))),
        ).subscribe();
    }),
    action("AUTHENTICATOR_REMOVE", (obs$: Observable<null>, lens, setState, getState) => {
        obs$.pipe(
            tap(() => setState(lens.authenticator_page.children.remove.status.set("submitting"))),
            switchMap(() => formOperation("RemoveAuthenticator", lens.authenticator_page.children.remove.get()(getState()))),
            tap((response) => setState(lens.authenticator_page.children.remove.set(response))),
            switchMap(() => formOperation("GetAuthenticatorPage", lens.authenticator_page.get()(getState()))),
            tap((response) => setState(lens.authenticator_page.set(response))),
        ).subscribe();
    }),
];
